export default __webpack_public_path__ + "assets/images/1d22df9a2a1a9528c9243eeeb20930f1.png";